import { View } from "@react-pdf/renderer";
import {
  ResumePDFIcon,
  type IconType,
} from "components/Resume/ResumePDF/common/ResumePDFIcon";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import {
  ResumePDFLink,
  ResumePDFSection,
  ResumePDFText,
} from "components/Resume/ResumePDF/common";
import type { ResumeProfile, ResumeWorkExperience } from "lib/redux/types";
import { extractUsernameFromURL } from "lib/utils/urlHelpers";

export const Profile = ({
  profile,
  themeColor,
  isPDF,
  workExperiences,
  enableHighlight = false,
}: {
  profile: ResumeProfile;
  themeColor: string;
  isPDF: boolean;
  workExperiences: ResumeWorkExperience[];
  enableHighlight?: boolean;
}) => {
  const { name, email, phone, url1, url2, summary, location } = profile;
  const iconProps = { email, phone, location, url1, url2 };
  const isOverflow = name.length > 20;
  return (
    <ResumePDFSection style={{ marginTop: spacing["4"] }}>
      <View
      style={{
        display:'flex',
        flexDirection: isOverflow ? "column" : "row",
        justifyContent: "flex-start",
        alignItems: "flex-start",
      }}
    >
      <ResumePDFText
        bold={true}
        themeColor={themeColor}
        style={{
          fontSize: "25pt",
          textAlign: "left",
        }}
      >
        {name}
      </ResumePDFText>
      
    </View>
    {workExperiences[0] &&
    workExperiences[0].endDate.toLowerCase() === "present" && (
      <ResumePDFText
        bold={true}
        italic={true}
        style={{
          fontSize: "10pt",
          opacity: 0.8,
          fontWeight: 500,
          flexWrap: "nowrap",
          color: themeColor,
        
          paddingBottom:1,
        
        }}
      >
        {workExperiences[0].jobTitle}
      </ResumePDFText>
    )}
     
    </ResumePDFSection>
  );
};
